import { Directive, HostBinding, InjectionToken, Input } from '@angular/core';

let nextUniqueId = 0;

/**
 * Injection token that can be used to reference instances of `MatError`. It serves as
 * alternative token to the actual `MatError` class which could cause unnecessary
 * retention of the class and its directive metadata.
 */
export const MAT_ERROR = new InjectionToken<MatErrorDirective>('MatError');

/** Single error message to be shown underneath the form-field. */
@Directive({
  selector: 'app-mat-error',
  providers: [{ provide: MAT_ERROR, useExisting: MatErrorDirective }],
})
export class MatErrorDirective {
  @HostBinding('attr.id')
  @Input()
  id: string = `mat-error-${nextUniqueId++}`;

  @HostBinding('class') hostClass = 'mat-error';
  @HostBinding('attr.aria-atomic') ariaAtomic = 'true';
  @HostBinding('attr.aria-live') ariaLive = 'polite';
}
